import styled from "@emotion/styled";
import {Payment} from "../../components/settings/components/Payment/Payment";
import {useParams} from "react-router-dom";

export const MobilePayments = () => {
  const { token, selectedPlanId } = useParams();
  return <>
    <SPaymentsWrapper>
      <Payment shortToken={token} selectedPlanId={selectedPlanId} />
    </SPaymentsWrapper>
  </ >
}

const SPaymentsWrapper = styled.div`
  height: calc(100vh - 70px);
`;